//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.0.0.0 (Newtonsoft.Json v13.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------







export interface AppConfiguration {
    clientEnviroment: ClientEnviroment;
    documentationPacks: DocumentationPack[];
    availableQueries: AvailableQueries;
}

export enum ClientEnviroment {
    Santander = 0,
    Sabadell = 1,
    Unicaja = 2,
    Experian = 3,
}

export interface DocumentationPack {
    packName: string | undefined;
    packDescription: string | undefined;
}

export interface AvailableQueries {
    requestors: AvailableRequestors;
    requests: AvailableRequests;
}

export interface AvailableRequestors {
    physicalPerson: boolean;
    legalEntity: boolean;
}

export interface AvailableRequests {
    clavePin: boolean;
    clavePinWithSMS: boolean;
    sms: boolean;
    videoId: boolean;
    knownClient: boolean;
}

export interface User {
    token: string | undefined;
    loginName: string | undefined;
    expiresAt: Date;
    appConfiguration: AppConfiguration;
}